import { Badge } from "primereact/badge";

export const columns=[    
       { 
        field: "name", 
        header: "Permissions",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"name")}  className="">          
                <p className="w-[6rem] cursor-pointer text-blue-600 hover:text-blue-800" >
                {row?.name}
                </p>
              </div>
            </>
          ),
       },
       { 
        field: "isMandatory", 
        header: "Is Mandatory",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"role_id")}  className="">          
                <p className="w-[6rem]">               
                 <Badge
                  className="w-[6rem]"
                  severity={
                    row?.isMandatory === true
                      ? "success"
                      : "danger"
                  }
                  value={row?.isMandatory?"Mandatory":"Not Mandatory"}
                ></Badge> 
                </p>
              </div>
            </>
          ), 
       },
       { 
        field: "active", 
        header: "Active",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"active")}  className="">          
                <p className="w-[6rem]">
                <Badge
                  className="w-[6rem]"
                  severity={
                    row?.active === true
                      ? "success"
                      : "danger"
                  }
                  value={row?.active?"Enabled":"Disabled"}
                ></Badge>             
                </p>
              </div>
            </>
          ), 
       },
]

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};